// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3ykrq","colCheckbox":"styles_colCheckbox__3hidN"};